import api from './api';
import { User } from '../types';

class UserService {
  async getAll(params?: any): Promise<User[]> {
    const response = await api.get('/users/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getTeachers(): Promise<User[]> {
    return this.getAll({ role: 'teacher' });
  }

  async getUser(id: number): Promise<User> {
    const response = await api.get(`/users/${id}/`);
    return response.data;
  }

  async create(data: Partial<User>): Promise<User> {
    const response = await api.post('/users/', data);
    return response.data;
  }

  async update(id: number, data: Partial<User>): Promise<User> {
    const response = await api.patch(`/users/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/users/${id}/`);
  }
}

const userService = new UserService();
export default userService;
